import { validate as validateRut } from '@validatecl/rut';

const useRut = () => {
    const validate = (rut) => {
        return validateRut(rut);
    };

    return {
        validate,
    };
};

export default useRut;
